<template>
  <div>
    <title-bar :title-stack="['SECAPI', 'Acessos', 'Veículos', 'Cadastrar']" />
    <section class="section is-main-section">
      <card-component title="Cadastrar Acesso de Veículo" icon="ballot">
        <FormAcessoVeiculo />
      </card-component>
    </section>
  </div>
</template>

<script>
import { defineComponent } from "vue";

import TitleBar from "@/components/TitleBar.vue";
import CardComponent from "@/components/Cards/CardComponent.vue";
import FormAcessoVeiculo from "@/components/Form/FormAcessoVeiculo.vue";

export default defineComponent({
  name: "ViewFormAcessoPessoa",
  components: {
    TitleBar,
    CardComponent,
    FormAcessoVeiculo,
  },
  data() {
    return {
      isTipoAcessoPessoa: null,
      pessoaSelecionada: {},
      empresaSelecionada: {},
      veiculoSelecionado: {},
    };
  },
  methods: {
    formAction() {
      // Implementar lógica de envio do formulário
      console.log("Dados enviados:", {
        pessoa: this.pessoaSelecionada,
        empresa: this.empresaSelecionada,
        veiculo: this.veiculoSelecionado,
      });
    },
  },
});
</script>
